import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ReactComponent as Close } from '../../assets/icons/close.svg'

const IconClose = ({ backTo, className }) => (
  <Link to={backTo} className={className}><Close/></Link>
)

IconClose.defaultProps = {
  backTo: '',
  className: ''
}

IconClose.propTypes = {
  backTo: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  className: PropTypes.string
}

export default IconClose
